import Auth from './Auth';

export default Auth
export { Auth as Base }
